<div class="ui-g loyalty-cluster" *ngIf="render.datatable">
  <div class="ui-g-12">

    <app-kontable #table data-testid="table" title = "{{ 'card_def.card_def_title' | translate }}"
                  [columns] = "['id', 'description', 'channelDescription', 'clusterDescription','rangeMin','rangeMax','cardPrefix',
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter}
                  ]"
                  [titles] = "['common.id', 'common.description', 'card_def.channel_id','card_def.cluster_id','card_def.range_min','card_def.range_max','card_def.card_prefix']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showRecoverButton]="true"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="cardDefService"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  [servicePermissions]="cardDefPermission"
                  (onAdd)="addNew($event)"
                  (onEdit)="edit($event)"
                  (onRecover)="recover($event)"
                  (onRemove)="remove($event)">
                <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
                  <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
                </ng-template>

                <ng-template #stateFilter data-testid="stateFilter" let-col>
                    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
                </ng-template>

    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-definition/loyalty-card-definition.component.html